import { render } from "./SpeakerForm.vue?vue&type=template&id=215528c3&scoped=true"
import script from "./SpeakerForm.vue?vue&type=script&lang=js"
export * from "./SpeakerForm.vue?vue&type=script&lang=js"

import "./SpeakerForm.vue?vue&type=style&index=0&id=215528c3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-215528c3"]])

export default __exports__